import { reactive } from "vue";

const state = reactive({
    modalController: null,
});

const methods = {
    setModalController: function (modalController) {
        state.modalController = modalController;
    },
    getModalController: function () {
        return state.modalController;
    }
};

export default {
    state: state,
    methods: methods,
}
